import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = { class: "top-container" }
const _hoisted_4 = { class: "items" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = {
  key: 0,
  class: "items"
}
const _hoisted_8 = { class: "social-items" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src", "alt", "aria-label"]
const _hoisted_11 = { class: "bottom-container" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("b", null, _toDisplayString(_ctx.aboutUsLink.title), 1),
          (_ctx.hasFaqs)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: _ctx.faqLink.name },
                lang: "en"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.faqLink.title), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: _ctx.aboutUsLink.url,
            target: "_blank"
          }, [
            _createTextVNode(_toDisplayString(_ctx.aboutUsLink.title) + " ", 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("general.openInNewTab")), 1),
            _cache[1] || (_cache[1] = _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "open-in-new",
              "aria-hidden": "true",
              focusable: "false",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none"
            }, [
              _createElementVNode("mask", {
                id: "mask0_149_1328",
                style: {"mask-type":"alpha"},
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24"
              }, [
                _createElementVNode("rect", {
                  width: "24",
                  height: "24",
                  fill: "#D9D9D9"
                })
              ]),
              _createElementVNode("g", { mask: "url(#mask0_149_1328)" }, [
                _createElementVNode("path", {
                  d: "M5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H12V5H5V19H19V12H21V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM9.7 15.7L8.3 14.3L17.6 5H14V3H21V10H19V6.4L9.7 15.7Z",
                  fill: "white"
                })
              ])
            ], -1))
          ], 8, _hoisted_5)
        ]),
        (_ctx.currentLocale === 'de')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t("general.followUs")), 1),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLinksSocial(), (link) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: link.name,
                    target: "_blank",
                    href: link.url
                  }, [
                    _createElementVNode("img", {
                      src: require(`@/assets/icons/socialmedia/${link.name}.svg`),
                      alt: `${link.name} icon`,
                      "aria-label": link.name
                    }, null, 8, _hoisted_10)
                  ], 8, _hoisted_9))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, {
          to: { name: _ctx.imprintLink.name }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.imprintLink.title), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: { name: _ctx.privacyLink.name }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.privacyLink.title), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("a", {
          href: "javascript:void(0)",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCookiePreferences && _ctx.openCookiePreferences(...args)), ["prevent"]))
        }, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('general.cookieSettings')
          }, null, 8, _hoisted_12)
        ]),
        _createVNode(_component_router_link, {
          to: { name: _ctx.accessibilityLink.name }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.accessibilityLink.title), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}